<script setup lang="ts">
import { ref, watch } from 'vue';

import { isRadarFileUrl, resolveAuthorizedFileUrl } from '@/core/authorizedFile';

const props = defineProps<{
	src?: string;
}>();

const resolvedSrc = ref('');

watch(
	() => props.src,
	(src, _previous, onCleanup) => {
		let cancelled = false;
		onCleanup(() => {
			cancelled = true;
		});

		if (!src || !src.trim()) {
			resolvedSrc.value = '';
			return;
		}

		if (!isRadarFileUrl(src)) {
			resolvedSrc.value = src;
			return;
		}

		void resolveAuthorizedFileUrl(src)
			.then((url) => {
				if (!cancelled) resolvedSrc.value = url;
			})
			.catch(() => {
				if (!cancelled) resolvedSrc.value = '';
			});
	},
	{ immediate: true },
);
</script>

<template>
	<img :src="resolvedSrc || undefined" />
</template>
